export default __webpack_public_path__ + "static/media/10.22ef7d77.png";